export const getImageAspectRatio = (viewPortSize, firstValue, secondValue) => {
  const imageAspectRatio = viewPortSize ? firstValue : secondValue;
  return imageAspectRatio;
};
